"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARE_BUTTON = void 0;
const SHARE_BUTTON = exports.SHARE_BUTTON = 'share-button';
